import { render, staticRenderFns } from "./PersonalChanges.vue?vue&type=template&id=5e336184"
import script from "./PersonalChanges.vue?vue&type=script&lang=js"
export * from "./PersonalChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports